if (!customElements.get("complementary-quick-add")) {
  customElements.define(
    "complementary-quick-add",
    class ComplementaryQuickAdd extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector("form");
        if (!this.form || this.form.dataset.quickAddBound === "true") {
          return;
        }
        this.form.dataset.quickAddBound = "true";
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      }

      onSubmitHandler(event) {
        event.preventDefault();

        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) {
          return;
        }

        const variantId = Number(this.form.querySelector("[name=id]").value);
        const minicart = document.querySelector("mini-cart");

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        this.querySelector(".button-overlay-spinner").classList.remove("hidden");

        const body = { items: [{ id: variantId, quantity: 1 }] };
        if (minicart) {
          body.sections = minicart.getSectionsToRender().map((section) => section.section);
          body.sections_url = window.location.pathname;
        }

        fetch(`${routes.cart_add_url}.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "ComplementaryProducts",
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              minicart?.updateSectionContents();
              return;
            }

            if (minicart && response.sections) {
              minicart.renderContents(response);
            }

            if (window.themeSettings.redirectToCart) {
              location.href = window.routes.cart_url;
            } else {
              minicart?.open(submitButton);
            }

            publish(PUB_SUB_EVENTS.cartItemAdd, {
              source: "ComplementaryProducts",
              items: response.items,
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
            this.querySelector(".button-overlay-spinner").classList.add("hidden");
          });
      }
    },
  );
}
